const privacy = {
  title: "Privacy Policy",
  updated: "2026-09-15",
  intro:
    "This policy explains what Grassurn Technologies collects when you visit grassurntech.com, why, and what you can do about it.",
  sections: [
    {
      heading: "What we collect",
      body: [
        "Analytics and session recording. We use PostHog to record how visitors move through the site, including session replays, surveys and web-vitals measurements. Recording only starts if you accept analytics in the consent banner, and form fields are masked so anything you type is not captured.",
        "Information you send us. The contact form collects your name, email, company, project type and message. Job applications collect your details and your uploaded resume file.",
      ],
    },
    {
      heading: "Where it is stored",
      body: [
        "Form submissions and applications are stored in MongoDB Atlas. Uploaded resumes are stored on our application server. Analytics data is held by PostHog.",
      ],
    },
    {
      heading: "Your choices",
      body: [
        "You can decline analytics in the consent banner, and change your mind at any time using the Cookie settings link in the footer. Declining does not affect your ability to use the site or contact us.",
        "To ask what we hold about you, or to have it deleted, email hello@grassurntech.com.",
      ],
    },
  ],
};

export default privacy;
